import {useState} from 'react'
import {toursData} from "../helper/data";
import {Tours} from "../components/Tours";
import Container from "react-bootstrap/Container"
import BookList from"../components/BookList";
import {bookedData} from "../helper/data";

const Home = () => {
    // const [tours, setTours]=useState(toursData)
    const[appointment, setAppointment]=useState(bookedData)
  return (
    <Container className='text-center mt-2 vh-100'>
        <h1> Clarus Tourism</h1>
        <Tours 
        toursData={toursData}
        appointment={appointment}
        setAppointment={setAppointment}
        />
        <BookList
        appointment={appointment}
        setAppointment={setAppointment}
        
        />
    </Container>
  )
}

export default Home